<template>
  <div class="hsec">
    <loader v-if="!customHtml"></loader>
    <div class="remoteContent" v-html="customHtml"></div>
    <!--    TODO Remove after testing on production-->
    <div v-if="reservedInfo">
    <div class="row top">
      <div class="col header-text">
        <h1>Privacy Policy</h1>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="row privacy-content">
            <div>
              <p class="text-header">Introduction</p>
              <p class="text">This privacy policy explains which personal data of the users of Income Marketplace (<a href="//www.getincome.com">www.getincome.com</a>, hereinafter “<strong>Income
                Marketplace</strong>”) is processed by
                Income Company OÜ, how it is collected and processed, what is the legal basis for that, which rights do the users have and how is the protection of the personal data arranged.</p>
              <p class="text">
                Income Company OÜ (company registration number 16014116, registered address Maakri 19/2, Tallinn, 10145, Estonia, hereinafter “<strong>Income</strong>”) is the operator of Income
                Marketplace and thus,
                it is the person responsible for processing of personal data collected at Income Marketplace.
              </p>
              <p class="text">
                Users of Income Marketplace are persons who use, have used or have applied for becoming a user of Income Marketplace (hereinafter “<strong>Investor</strong>”).
              </p>
              <p class="text">
                Income processes Investor’s personal data in accordance with the EU General Data Protection Regulation (the “<strong>GDPR</strong>”) and applicable national laws.
              </p>
              <p class="text-header">What type of information do we collect and process?</p>
              <p class="text">Income collects and processes several categories of Investor’s personal data:</p>
              <ul>
                <li><span class="underline">Investor’s identification data</span>: name, surname, personal identification code, date of birth, age, data regarding identification document;</li>
                <li><span class="underline">Investor’s contact details</span>:
                  <p>(a) In case of natural person: place of residence, citizenship, e-mail address, telephone number, copy of an identity document, photograph, Investor’s bank account
                    number, area of work and position,</p>
                  <p>(b) In case of legal entity: e-mail, telephone and personal data about physical person who represents the Investor who is a legal entity, the business name, registration
                    number, address data about the owners, ultimate beneficial owners, management board members;</p>
                </li>
                <li><span class="underline">Analytical cookies</span>: are used to collect and analyse information about your actions on the Marketplace and to improve Marketplace functionality. These
                  cookies are used based on the
                  legitimate interest of Income to collect statistics on Marketplace visits and to improve operation of the Marketplace. Analytical cookies are kept on your device permanently.
                </li>
                <li><span class="underline">Investor’s  transaction  data</span>: information regarding Investor’s transactions on Income Marketplace, applications, agreements, transactions,
                  transaction profiles, transaction preferences and settings, annual returns, records of payments, accounting reports;
                </li>
                <li><span class="underline">Investor’s compliance related data</span>: information gained from risk assessment based activities, data that enables Income to perform its due diligence
                  measures regarding anti-money laundering and terrorist financing prevention regulation and to ensure compliance with international sanctions, including the purpose of the business
                  relationship and whether the Investor is a politically exposed person, as well as data on origin of assets or wealth, such as data regarding the Investor's transaction partners and
                  business activities, and other information provided by the Investor or obtained from third persons or publicly available sources permitted by law;
                </li>
                <li><span class="underline">Investor’s  communication  and  usage  data</span>: data on communication between the Investor and Income, e.g. e-mails, video and/or audio recordings,
                  login details, account usage data (e.g. time and number of log-ins, log-ins via Facebook, LinkedIn or other third-party service providers, the so-called log-in tokens), IP address,
                  cookies (please see our Cookie Policy
                  <router-link to="/cookie">here</router-link>
                  ), behaviour and usage data
                  2on Income Marketplace from the devices used to connect with Income Marketplace (e.g. computers, tablets, mobile devices).
                </li>
              </ul>
              <p class="text-header">Why do we process personal data?</p>
              <p class="text">According to the GDPR, we are only allowed to collect and process Investor’s personal information if we have a justified reason to do so. Therefore, Income will use
                Investor’s personal data for any of the following reasons:</p>
              <ul>
                <li>
                  <span class="underline">To conclude and fulfil the agreements and provide services to Investor (GDPR Art 6(1)(b))</span>:
                  – this is the main purpose for processing Investor’s personal data i.e. to fulfil, document, execute and administer the agreements made between Income and the Investor. The aforesaid
                  includes Investor identification process, creating an account for the Investor to access the Income Marketplace so that Income can render its services to the Investor. As the
                  identification of Investor and verification of Investor’s identification documents is carried out remotely, Income uses verification services provided by a professional third-party.
                </li>
                <li>
                  <span class="underline">Upon Investor’s consent (GDPR Art 6(1)(a))</span>:
                  - In case where Investor has given consent to Income for processing of his or her personal data for one or more purposes. These could be when there are no contracts signed between
                  Investor and Income yet, e.g. when Investor wishes to browse Income Marketplace website and seeks to find more information about Income and its services, then Investor is usually
                  requested to give a consent to Income to process information which may include personal information. In practice this may be accepting the Cookies Policy (available
                  <router-link to="/cookie">here</router-link>
                  ) at the
                  Income Marketplace website or by contacting Income through e-mail which is expected to be replied by Income. Collected data and cookies are used on the Income Marketplace for the
                  purposes of rendering and improving the services for the Investors. In case where Investor has given consent for personal data processing, the Investor may also any time withdraw the
                  consent. As a principle, Income is allowed to process Investor’s personal data given upon his/her consent until such consent has been withdrawn by Investor.
                </li>
                <li>
                  <span class="underline">To fulfill obligations arising from law (GDPR Art 6(1)(c)) </span>:
                  – on certain grounds Income has an obligation arising from law to process personal data, whereas it cannot withhold from processing of the personal data. On these grounds the
                  Investor does not have the right to restrict Income to process the personal data. These mainly relate to submitting data to state institutions and for accounting purposes. For
                  example, Income may be obliged to submit Investor’s personal data to state institutions (incl. Police and Border Guard Board, Tax Board etc). In such cases, Income will notify the
                  respective Investors of the communication of its data if and to the extent allowed by law. Income also processes Investor’s personal data to enable the correct connecting of
                  Investor’s identification details with their financial data and bank account details, so that we follow the accounting rules.
                </li>
                <li>
                  <span class="underline">In case of Income’s legitimate interest (GDPR Art 6(1)(f))</span>:
                  - in some situations it might be in Income’s legitimate interest to process Investors personal data. These would include improving the Investor’s user experience at the Income
                  Marketplace, general administration and management of Income’s business activities and business risks, keeping communication with the Investor, protect the rights of the parties
                  involved in the Income Marketplace, where it may be necessary for Income to take action, collect statistics regarding the use of Income’s services by Investors in order to analyse
                  and improve the quality of the services. Income will also need to ensure that Investor’s payments and withdrawals are done correctly, Investor receives the agreed reports and
                  notices, as well as Income is able to take necessary measures for quality control and prevention of fraud or abuse of Income Marketplace services. In relation to registration of the
                  Investor as Income Marketplace user and the aforesaid contractual purposes, Income may also need to contact the Investor, including to send the Investor registration reminders in
                  case the registration process has not been completed by the Investor and/or verification reminders in case the Investor has not submitted the requested information and documentation
                  to Income for completion of verification and registration process. It is also in Income’s legitimate interest to request information from the Investor in order to perform necessary
                  Investor due diligence and the Investor shall provide the requested information in the form and within the time period indicated by Income.
                </li>
              </ul>
              <p class="text">Upon processing of personal data under this category, Income will consider whether it can achieve the same objective by some other means, whether processing or refraining
                from processing may harm Investor’s rights.</p>
              <p class="text">When the processing is based on Income’s or a third person’s legitimate interest, the Investor has the right to object, on grounds relating to Investor’s particular
                situation, at any time to such processing by delivering a respective notice to Income. Investor can also obtain from us information on the balancing test upon request.</p>
              <p class="text-header">How long do we store the personal information?</p>
              <p class="text">All Investor’s personal data and agreements are stored for as long as it is necessary to fulfil the purposes outlined in this Privacy Policy, unless Income is required or
                permitted by law to retain the information for longer period. To be compliant with applicable regulations, Income will store the Investor’s personal data for 7 years counted from the
                termination of a contractual relationship between Investor and Income.</p>
              <p class="text-header">How do we collect information?</p>
              <p class="text">In order to provide information and services and to ensure the obligations imposed by law, information about Investor is collected in several ways: (a) directly from
                Investor (e.g. from application form, e-mails, communication by the telephone or via other communication channels); (b) in an automated way (e.g. from device data, IP address, social
                network information and content that may contain identification and social account data, cookies); (c) from third parties (e.g. publicly available information like public registers,
                social networks, cooperation partners, affiliated companies, Income group entities).</p>
              <p class="text-header">Where do we process personal data?</p>
              <p class="text">Investor’s personal data is processed within the European Economic Area.</p>
              <p class="text-header">Do we transfer information to third parties?</p>
              <p class="text">The Investor’s data is processed by Income and Income’s cooperation partners which provide the following services in connection performance of contracts with Investors
                and Income’s legitimate interests explained above (compliance obligations): Investor identification and verification services, data storing, IT, accounting, communication, email
                validation, banking, customer relationship management and intermediary services that facilitate integration with other services.</p>
              <p class="text">Income has a right to disclose the Investor’s data to the following persons, insofar as such information is necessary for the performance of functions delegated to them
                in connection with the operations of the Income Marketplace:</p>
              <ul>
                <li>to any person related to the fulfilment of commitments arising to Income from the agreements made between Income and the Investor (including to communications service providers,
                  payment intermediaries, Investor identification and verification services, credit institutions, IT service providers, marketing service providers);
                </li>
                <li>to Income’s group companies;</li>
                <li>to third parties who provide legal and collection services upon enforcement of Investor’s rights towards loan originators and borrowers;</li>
                <li>to Income’s legal, accounting, and/or auditing service providers,</li>
                <li>for the needs of analysing anonymised statistics and any other anonymised research;</li>
                <li>to state institutions and authorities when we are obliged from laws and regulations (as described above).</li>
              </ul>
              <p class="text">Income is entitled to transfer Investor’s personal data to third persons in any other case only when there is justified interest for ensuring the performance of the
                agreements signed between Investor and Income and the transfer of information does not contradict the law.</p>
              <p class="text-header">Collecting of personal data from third parties</p>
              <p class="text">Income may obtain and/or receive information about the Investor from payment institutions, public and private databases, social networks, and other publicly accessible
                sources for the purposes of carrying out Investor identification and due diligence obligations related to the obligations arising from anti-money laundering and terrorist financing
                prevention laws and regulations.</p>
              <p class="text-header">What are the Investor’s rights as a data subject?</p>
              <p class="text">Investor has all the rights of a data subject stipulated in the GDPR, including the following:</p>
              <ul>
                <li>The right to obtain confirmation as to whether or not personal data concerning him or her are being processed and a copy of that data.</li>
                <li>The right to obtain the rectification of inaccurate personal data concerning him or her, including to have incomplete personal data completed.</li>
                <li>The right to obtain the erasure of his or her personal data where one of the following applies: (i) the personal data are no longer necessary in relation to the purposes for which
                  they were collected or otherwise processed; (ii) Investor withdraws the consent on which the processing is based and there is no other legal ground for the processing; (iii) Investor
                  objects to processing carried out for our or a third person’s legitimate interest and there are no overriding legitimate grounds for the processing, or Investor objects to processing
                  carried out for direct marketing purposes; (iv) the personal data have been unlawfully processed; or (v) the personal data have to be erased for compliance with our legal obligation
                  under EU or Member State law. The previous does not apply if we have a legal basis to still process the personal data, including when and to the extent that processing is necessary:
                  (i) for compliance with our legal obligation under EU or Member State law; and (ii) for the establishment, exercise or defence of legal claims.
                </li>
                <li>The right to obtain restriction of processing where one of the following applies: (i) the accuracy of the personal data is contested by Investor, for a period enabling us to verify
                  the accuracy of the personal data; (ii) the processing is unlawful and Investor opposes the erasure of the personal data and request the restriction of their use instead; (iii) we no
                  longer need the personal data for the purposes of the processing, but they are required by Investor for the establishment, exercise or defence of legal claims; or (iv) Investor has
                  objected to processing carried out for our or a third person’s legitimate interest pending the verification whether the legitimate grounds used by us override those of Investor.
                  Where processing has been restricted, such personal data shall, with the exception of storage, only be processed with Investor’s consent or for the establishment, exercise or defence
                  of legal claims or for the protection of the rights of another natural or legal person or for reasons of important public interest of the European Union or of a Member State of
                  European Union. If Investor has obtained restriction of processing, we will inform Investor before the restriction of processing is lifted.
                </li>
                <li>The right to receive his or her personal data, which he or she has provided to us, in a structured, commonly used and machine-readable format and the right to transmit those data
                  to another controller without hindrance from us where: (i) the processing is based on consent or on a contract; and (ii) the processing is carried out by automated means; including
                  to have the personal data transmitted directly to another controller, where technically feasible.
                </li>
                <li>The right to object, on grounds relating to Investor’s particular situation, at any time to processing of personal data which is based on our or a third person’s legitimate
                  interest. We shall no longer process the personal data unless we demonstrate compelling legitimate grounds for the processing which override Investor’s interests, rights and freedoms
                  or for the establishment, exercise or defence of legal claims, except for when Investor objects to the processing of personal data for direct marketing purposes, in which case we
                  shall no longer process your personal data for such purposes. If the processing is based on legitimate interest, Investor can also obtain from us information on the balancing test
                  upon request.
                </li>
              </ul>
              <p class="text">Note that not all rights listed above are absolute and may be restricted for purposes allowed under the GDPR. Investor can exercise his or her rights by contacting us on
                the contact details shown at the beginning of this Privacy Policy. We will respond to queries within one month of receipt of the request. That period may be extended by two further
                months where necessary, considering the complexity and number of the requests, in which case we will notify you thereof.</p>
              <p class="text">We encourage the Investor to come to us in the first instance with any complaints, but the Investor is entitled to lodge a complaint with a supervisory authority, in
                particular in the Member State of the European Union of his or her habitual residence, place of work or alleged infringement of the GDPR, including the Estonian Data Protection
                Inspectorate:</p>
              <p class="text">Data Protection Inspectorate<br/>Address: Tatari street 39, 10134 Tallinn, Estonia<br/>Telephone: +372 627 4135<br/>E-mail: info@aki.ee</p>
              <p class="text-header">Changes in the Privacy Policy</p>
              <p class="text">Income has the right to make changes to the Privacy Policy at any time. In case of any updates to the Privacy Policy, Income will post the Privacy Policy on the Income
                Marketplace and inform the Investors also individually via email. Any updated version of the Privacy Policy replaces all previous versions.</p>
              <p class="text-header">Questions & Queries</p>
              <p class="text">If you have any questions regarding the Privacy Policy or if you wish to obtain additional information on how to exercise the rights specified herein or submit any
                requests to Income regarding personal data protection, you can contact Income by writing an email to dpo@getincome.com or by sending a signed request to Income at its registered
                address: Income Company OÜ, Maakri 19/2, Tallinn, Harju county, 10145, Estonia.</p>
              <p class="text"></p>
              <p class="text">Created at 14.10.2020</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>

import Loader from '@/components/Loader'
import marketingHelper from '@/helpers/marketingHelper'
export default {
  name: 'Privacy',
  components: {Loader},
  data()
  {
    return {
      customHtml: '',
      reservedInfo: false
    }
  },
  mounted()
  {
    marketingHelper.getMarketingRequest('privacy').then((response) =>
    {
      this.customHtml = marketingHelper.parseContent(response)
    }).catch(error =>
    {
      console.log(error)
      this.reservedInfo = true
      this.customHtml = ' '
    })
  }
}
</script>

<style scoped lang="scss">

.hsec {
  .top {
    border-bottom: 1px solid #c3c3c3;
    margin-bottom: 10px;
  }
}

.header-text {
  font-weight: bold;
  margin: 52px auto 16px 5%;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.top-block {
  background-repeat: no-repeat;
  background-size: cover;
}

.top-title {
  font-weight: bold;
  font-size: 36px;
  line-height: 30px;
  text-align: center;
  color: #000000;
  margin-top: 60px;
  margin-bottom: 60px;
  width: 100%;
}

.text-header {
  margin: 45px auto 12px 1%;
  font-weight: bold;
}

.underline {
  text-decoration: underline;
}

.text {
  margin-left: 2%;
  text-align: justify;
}

.privacy-content {
  text-align: justify;
}
</style>
